import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ServiceModel from "../../models/service";

export default class AdministeredServiceRepository extends BaseRepository {
  static modelClass = ServiceModel;
  modelName = "service";

  async addRemoveService(params, addService = true, payload) {
    const otherThanProviderIdParams = {};
    for (const key in params) {
      if (key !== "providerId") {
        otherThanProviderIdParams[key] = params[key];
      }
    }
    const providerId = params?.providerId || null;
    if (providerId) {
      return await super.post(payload, {
        urlPath: "provider/" + providerId + (addService ? "/add_service/" : "/remove_service/"),
      });
    }
  }

  async query(params, isAvailableService = true) {
    const otherThanProviderIdParams = {};
    for (const key in params) {
      if (key !== "providerId") {
        otherThanProviderIdParams[key] = params[key];
      }
    }
    const providerId = params?.providerId || null;
    if (providerId) {
      return await super.query({
        urlPath:
          "provider/" +
          providerId +
          (isAvailableService ? "/available_services/?" : "/services/?") +
          qs.stringify(otherThanProviderIdParams),
      });
    }
  }
}
